import React from 'react';
import { Field } from 'redux-form';

import { renderTextAreaField } from '../../../../../../utils/redux-form-helper';

import { FlexFormInputFull } from '../../common';

const ExclusiveUseOptionsFormFields = ({ values }: Object) => {
  return (
    <React.Fragment>
      <FlexFormInputFull>
        <Field
          name="Exclusive Rights"
          component={renderTextAreaField}
          label="Exclusive Rights"
          rows="3"
          maxLength="1000"
          showLabel
        />
      </FlexFormInputFull>
    </React.Fragment>
  );
};

export default ExclusiveUseOptionsFormFields;
